import React, { useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import {
  Avatar,
  Box,
  ButtonBase,
  Hidden,
  Menu,
  MenuItem,
  Typography,
  makeStyles,
  SvgIcon,
  Button,
  Grid
} from '@material-ui/core';
import useAuth from 'src/hooks/useAuth';
import {
  PlusCircle as PlusCircleIcon,
  Download as DownloadIcon,
  Upload as UploadIcon
} from 'react-feather';
import Label from 'src/components/Label';

import { getLocalFloat } from 'src/utils/helperfunctions';

const useStyles = makeStyles(theme => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1)
  },
  popover: {
    width: 200
  }
}));

const getStatusLabel = floatStatus => {
  const map = {
    notActive: {
      text: 'Non Active Float',
      color: 'warning'
    },
    active: {
      text: 'Float Active',
      color: 'success'
    }
    // unprocessed: {
    //   text: 'unprocessed',
    //   color: 'error'
    // }
  };

  const { text, color } = map[floatStatus];

  return <Label color={color}>{text}</Label>;
};

const POSFunctions = () => {
  const float = getLocalFloat();

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        // component={ButtonBase}
      >
        <Grid container spacing={1}>
        <Grid item>
            <Button
              // component={ButtonBase}
              color="secondary"
              variant="contained"
              to={`/app/pos/weighbridge/new`}
              component={RouterLink}
              startIcon={
                <SvgIcon fontSize="small">
                  <PlusCircleIcon />
                </SvgIcon>
              }
            >
              New Weighbridge Note
            </Button>
          </Grid>
          <Grid item>
            <Button
              // component={ButtonBase}
              color="secondary"
              variant="contained"
              to={`/app/pos/purchases/new`}
              component={RouterLink}
              startIcon={
                <SvgIcon fontSize="small">
                  <PlusCircleIcon />
                </SvgIcon>
              }
            >
              New Purchase
            </Button>
          </Grid>
          <Grid item>
            <Button
              // component={ButtonBase}
              color="secondary"
              variant="contained"
              to={`/app/pos/sales/new`}
              component={RouterLink}
              startIcon={
                <SvgIcon fontSize="small">
                  <PlusCircleIcon />
                </SvgIcon>
              }
            >
              New Sale
            </Button>
          </Grid>
          <Grid item></Grid>
          <Grid item>
            <Box p={1} alignContent="center" alignItems="center">
              {float && float.id
                ? getStatusLabel('active')
                : getStatusLabel('notActive')}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default POSFunctions;
